import { FileText, MessageSquare, Sparkles } from 'lucide-react';

import type { TemplateAr } from '../../template-data';

export const automateOpenCustomFieldsFillUpAr: TemplateAr = {
  name: 'أتمتة تعبئة حقول Open المخصصة بالذكاء الاصطناعي',
  description:
    'عبّئ حقول Open المخصصة تلقائياً أثناء المحادثة، وأعفِ فريق الدعم من الإدخال اليدوي.',
  category: 'دعم العملاء',
  workflow: [
    { icon: MessageSquare, label: 'العميل' },
    { icon: Sparkles, label: 'استخراج ذكي' },
    { icon: FileText, label: 'الحقول معبّأة', final: true },
  ],
  detailDescription: {
    paragraph1:
      'عبّي حقول Open وأنت في المحادثة، مو بعد ما تسكّر التذكرة. الـ AI يقرأ محادثات عملائك، ويطلع منها النقاط الأساسية، ويعبّي الحقول المخصصة لحظياً.',
    paragraph2:
      'بيانات الحقول تنزل مباشرة في تذاكر Open عندك. والتكامل أصلي مع كل خصائص Open وسير العمل فيه، والـ AI يتأقلم مع الإعدادات اللي عندك أنت.',
  },
  benefits: [
    'خلّص موظفيك من الإدخال اليدوي',
    'كل تذكرة تطلع بحقول معبّاة بنفس الطريقة',
    'وقت معالجة التذكرة ينزل وتلاحظ الفرق',
    'تقاريرك تطلع أدق',
    'كل تعبئة لها سجل تدقيق كامل للامتثال',
    'يشتغل داخل Open بشكل أصلي',
  ],
};
